module.exports = __webpack_public_path__ + "media/images/jog-004e59b1461b8c8d9801cec144b60562.png";